import { DefaultImages } from 'shared/constants';

import { GenericStrainType } from './generic-product.types';
import { GenericCategory } from '../generic-category';

export function getDefaultProductImage(category: GenericCategory | null, strainType: GenericStrainType | null): string {
  if (strainType && strainType in DefaultImages) {
    return DefaultImages[strainType];
  }

  if (category && category in DefaultImages) {
    return DefaultImages[category];
  }

  console.error(
    new Error(`could not resolve defaultImage for strainType: ${String(strainType)}, category: ${String(category)}`)
  );

  return '';
}
